export default __webpack_public_path__ + "static/media/AUDITORIA E CONTABILIDADE.56bdd6f5.pdf";